import { useEffect, useState } from 'react';
import { useCommonConfig } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useLocalStorage } from 'modules/taboola-common-frontend-modules/storage';

export const useTimedElementVisibility = elementId => {
    const { [elementId]: maxDurationToHideInDays } = useCommonConfig([elementId]);
    const [isVisible, setIsVisible] = useState(true);
    const [getLocalStorage, setLocalStorage] = useLocalStorage();

    useEffect(() => {
        const storedTimeString = getLocalStorage(elementId);
        if (!storedTimeString) return;

        const expirationDate = new Date(storedTimeString);
        expirationDate.setDate(expirationDate.getDate() + maxDurationToHideInDays);
        setIsVisible(Date.now() >= expirationDate.getTime());
    }, [elementId, maxDurationToHideInDays, getLocalStorage]);

    const hideElement = () => {
        setIsVisible(false);
        setLocalStorage(elementId, new Date().toISOString());
    };

    return { isVisible, hideElement };
};
